import { createSlice } from "@reduxjs/toolkit";
import { isExact } from "utils/isEqual";

let defaultFormValues = {
  file_type: { label: "Database", value: "db" },
  // data_source: { label: "DATABASE", value: "DATABASE" },
  test_size: 0,
  layer_list: {
    1: {
      type: { label: "Dense", value: "dense" },
    },
  },
  param_grid: {
    1: {},
  },
  variable: { label: "None", value: "none" },
};

const initialState = {
  property: {
    form: {},
    activeBlockId: null,
    isOpen: false,
    blockProperties: [],
  },
  pipeline: {
    form: {},
    activeBlockId: null,
    isOpen: false,
    blockProperties: [],
  },
  visual: {
    isOpen: false,
    selected: null,
  },
  isFetchingProjectState: false,
  currFunctCode: "",
  func_name: "",
  openfunctDesc: false,
};

export const rightPanelSlice = createSlice({
  name: "property",
  initialState,
  reducers: {
    handleOpenFuncDesc: (state, __) => {
      state.openfunctDesc = true;
    },
    setActiveBlockId: (state, action) => {
      state.property.activeBlockId = action.payload.id;
    },
    closeFuncDesc: (state, __) => {
      state.openfunctDesc = false;
    },
    openProperties: (state, action) => {
      let { id, inputProperties, projectId, func_code, func_name, type } =
        action.payload;
      state.visual.isOpen = false;
      let isPipeline = isExact(type, "pipeline");
      let isFunction = isExact(type, "function");

      state.pipeline.isOpen = isPipeline;
      state.property.isOpen = isFunction;
      state.currFunctCode = func_code;
      state.func_name = func_name;

      if (isPipeline) {
        // Getting existing project form values
        let currentProjectForm = state.pipeline.form[projectId];

        // Append each blocks input state and setting the initial value to null.
        let formValues = inputProperties.reduce((prev, curr) => {
          return { ...prev, [curr.name]: null };
        }, {});

        // Updating the form state
        state.pipeline.form = {
          ...state.pipeline.form,
          [projectId]: {
            ...currentProjectForm,
            [id]: {
              ...formValues,
              ...defaultFormValues,
              ...currentProjectForm?.[id],
            },
          },
        };
        state.pipeline.blockProperties = inputProperties;
      }

      if (isFunction) {
        // Getting existing project form values
        let currentProjectForm = state.property.form[projectId];

        // Append each blocks input state and setting the initial value to null.
        let formValues = inputProperties.reduce((prev, curr) => {
          return { ...prev, [curr.name]: null };
        }, {});

        // Updating the form state
        state.property.form = {
          ...state.property.form,
          [projectId]: {
            ...currentProjectForm,
            [id]: {
              ...formValues,
              ...defaultFormValues,
              ...currentProjectForm?.[id],
            },
          },
        };
        state.property.blockProperties = inputProperties;
      }

      state.property.activeBlockId = id;
      state.visual.isOpen = false;
      state.visual.selected = null;

      state.property.isOpen = isFunction;
      state.pipeline.isOpen = isPipeline;
    },
    closeProperties: (state, action) => {
      let { type } = action.payload;

      let isPipeline = isExact(type, "pipeline");
      let isFunction = isExact(type, "function");
      let isSwitcher = isExact(type, "switch")

      if (isFunction) {

        state.property = {
          ...state.property,
          blockProperties: [],
          activeBlockId: null,
          isOpen: false
        }
        
        // state.property.blockProperties = [];
        // state.property.activeBlockId = null;
        // state.property.isOpen = false;
      }

      if (isPipeline) {
        state.pipeline.blockProperties = [];
        state.property.activeBlockId = null;
        state.pipeline.isOpen = false;
      }

      if (isSwitcher) {
        state.property.activeBlockId = null;
        state.pipeline.isOpen = false;
        state.property.isOpen = false;
      }
    },
    setForm: (state, action) => {
      state.property.form = { ...state.property.form, ...action.payload };
    },
    setPipelineForm: (state, action) => {
      state.pipeline.form = { ...state.pipeline.form, ...action.payload };
    },
    updateForm: (state, action) => {
      let { name, value, projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.property.form;

      // Getting existing project form values
      let currentProjectForm = state.property.form[projectId];

      // Retrieve the active block id.
      let formValueId = state.property.activeBlockId;

      // Retrieving the form values for the active block
      let formValues =
        state.property.form?.[projectId]?.[state.property.activeBlockId] ?? {};

      state.property = {
        ...state.property,
        form: {
          ...form,
          [projectId]: {
            ...currentProjectForm,
            [formValueId]: {
              ...formValues,
              [name]: value,
            },
          },
        },
      };
    },
    updatePipelineForm: (state, action) => {
      let { name, value, projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.pipeline.form;

      // Getting existing project form values
      let currentProjectForm = state.pipeline.form[projectId];

      // Retrieve the active block id.
      let formValueId = state.property.activeBlockId;

      // Retrieving the form values for the active block
      let formValues =
        state.pipeline.form?.[projectId]?.[state.property.activeBlockId] ?? {};

      state.pipeline = {
        ...state.pipeline,
        form: {
          ...form,
          [projectId]: {
            ...currentProjectForm,
            [formValueId]: {
              ...formValues,
              [name]: value,
            },
          },
        },
      };
    },
    removeProjectForm: (state, action) => {
      let { projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.property.form;

      // Getting existing project form values
      delete form?.[projectId];

      // Assign the new form values.
      state.property = {
        ...state.property,
        form: {
          ...form,
        },
      };
    },
    removeProjectPipelineForm: (state, action) => {
      let { projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.pipeline.form;

      // Getting existing project form values
      delete form?.[projectId];

      // Assign the new form values.
      state.pipeline = {
        ...state.pipeline,
        form: {
          ...form,
        },
      };
    },

    removeBlockForm: (state, action) => {
      let { id: blockId, projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.property.form;

      // Getting existing project form values
      let currentProjectForm = form?.[projectId];

      // Creating a copy of the form state.
      let projectFormCopy = currentProjectForm;

      // deleting block form with the id.
      delete projectFormCopy?.[blockId];

      // console.log("form", formCopy);

      // Assign the new form values.
      state.property = {
        ...state.property,
        form: {
          ...form,
        },
      };
    },

    removePipelineBlockForm: (state, action) => {
      let { id: blockId, projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.pipeline.form;

      // Getting existing project form values
      let currentProjectForm = form?.[projectId];

      // Creating a copy of the form state.
      let projectFormCopy = currentProjectForm;

      // deleting block form with the id.
      delete projectFormCopy?.[blockId];

      // Assign the new form values.
      state.pipeline = {
        ...state.pipeline,
        form: {
          ...form,
        },
      };
    },

    addFormLayer: (state, action) => {
      let { formId, projectId } = action.payload;
      const { property } = state;

      // Retrieve all the forms and the current project form values
      const { form } = property;
      const currentProjectForm = form[projectId];

      // Retrieve the active block id and the form values for the active block
      const formBlockId = property?.activeBlockId;
      const formValues = form?.[projectId]?.[formBlockId];

      let layerLists = formValues?.layer_list;

      state.property = {
        ...property,
        form: {
          ...form,
          [projectId]: {
            ...currentProjectForm,
            [formBlockId]: {
              ...formValues,
              layer_list: {
                ...layerLists,
                [formId]: defaultFormValues?.layer_list?.[1],
              },
            },
          },
        },
      };
    },
    updateFormLayer: (state, action) => {
      let { formId, name, value, projectId } = action.payload;
      const { property } = state;

      // Retrieve all the forms and the current project form values
      const { form } = property;
      const currentProjectForm = form[projectId];

      // Retrieve the active block id and the form values for the active block
      const formBlockId = property?.activeBlockId;
      const formValues = form?.[projectId]?.[formBlockId];

      let layerLists = formValues?.layer_list;

      let layerListForm = layerLists?.[formId];

      state.property = {
        ...property,
        form: {
          ...form,
          [projectId]: {
            ...currentProjectForm,
            [formBlockId]: {
              ...formValues,
              layer_list: {
                ...layerLists,
                [formId]: {
                  ...layerListForm,
                  [name]: value,
                },
              },
            },
          },
        },
      };
    },
    removeFormLayer: (state, action) => {
      let { formId, projectId } = action.payload;
      const { property } = state;

      // Retrieve all the forms and the current project form values
      const { form } = property;
      const currentProjectForm = form[projectId];

      // Retrieve the active block id and the form values for the active block
      const formBlockId = property?.activeBlockId;
      const formValues = form?.[projectId]?.[formBlockId];

      let layerLists = formValues?.layer_list;

      delete layerLists?.[formId];

      state.property = {
        ...property,
        form: {
          ...form,
          [projectId]: {
            ...currentProjectForm,
            [formBlockId]: {
              ...formValues,
              layer_list: {
                ...layerLists,
              },
            },
          },
        },
      };
    },

    updateFormHyper: (state, action) => {
      const { projectId, name, value } = action.payload;
      const { property } = state;

      // Retrieve all the forms and the current project form values
      const { form } = property;
      const currentProjectForm = form[projectId];

      // Retrieve the active block id and the form values for the active block
      const formValueId = property.activeBlockId;
      const formValues = form?.[projectId]?.[formValueId];

      state.property = {
        ...property,
        form: {
          [projectId]: {
            ...currentProjectForm,
            [formValueId]: {
              ...formValues,
              hyp_params: {
                ...(formValues?.hyp_params ?? {}),
                [name]: value,
              },
            },
          },
        },
      };
    },

    updateFormParams: (state, action) => {
      const { data } = action.payload;
      const { property } = state;

      // Retrieve all the forms and the current project form values
      const { form } = property;
      const currentProjectForm = form[data?.projectId];

      // Retrieve the active block id and the form values for the active block
      const formValueId = property.activeBlockId;
      const formValues = form?.[data?.projectId]?.[formValueId];
      const paramGridValues = formValues?.param_grid?.[data?.id];

      // Update the state with the new form values
      state.property = {
        ...property,
        form: {
          ...form,
          [data?.projectId]: {
            ...currentProjectForm,
            [formValueId]: {
              ...formValues,
              param_grid: {
                ...formValues?.param_grid,
                [data?.id]: {
                  ...(paramGridValues || {}),
                  ...data,
                },
              },
            },
          },
        },
      };
    },
    removeFormParams: (state, action) => {
      let { id, projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.property.form;

      // Getting existing project form values
      let currentProjectForm = form[projectId];

      // Retrieve the active block id.
      let formValueId = state.property.activeBlockId;

      // Retrieving the form values for the active block
      let formValues = form?.[projectId]?.[state.property.activeBlockId] ?? {};

      let param_state = formValues?.param_grid;

      delete param_state[id];

      state.property.form = {
        ...form,
        [projectId]: {
          ...currentProjectForm,
          [formValueId]: {
            ...formValues,
            param_grid: param_state,
          },
        },
      };
    },

    updateLayerList: (state, action) => {
      let { type, data, id, projectId } = action.payload;
      let { property } = state;

      // Retrieve all the forms and the current project form values
      const { form } = property;
      const currentProjectForm = form[projectId];

      // let update
    },

    resetCurrentTabForm: (state, action) => {
      let { projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.property.form;

      state.property.form = {
        ...form,
        [projectId]: {},
      };
    },
    removeTabForm: (state, action) => {
      let { projectId } = action.payload;

      // Retrieve all the forms.
      let form = state.property.form;
      let pipelineForm = state.pipeline.form;

      delete form[projectId];
      delete form[projectId];

      state.property.form = form;
      state.pipeline.form = pipelineForm;
    },

    setIsFetchingProjectState: (state, action) => {
      state.isFetchingProjectState = action.payload;
    },

    // Visual panel functions
    closeVisual: (state, action) => {
      state.visual.isOpen = false;
      state.visual.selected = null;
    },
    openVisual: (state, action) => {
      state.property.isOpen = false;
      state.visual.selected = action.payload;
      state.property.activeBlockId = null;
      state.visual.isOpen = true;
    },

    reset: () => initialState,
  },
});

export const {
  closeProperties,
  openProperties,
  updateForm,
  updateFormHyper,
  updateFormParams,
  updateFormLayer,
  removeFormLayer,
  closeVisual,
  openVisual,
  setForm,
  removeFormParams,
  handleOpenFuncDesc,
  closeFuncDesc,
  setActiveBlockId,
  removeBlockForm,
  resetCurrentTabForm,
  removeTabForm,
  addFormLayer,
  reset,
  removeProjectForm,
  setIsFetchingProjectState,
  updatePipelineForm,
  removeProjectPipelineForm,
  setPipelineForm
} = rightPanelSlice.actions;

export default rightPanelSlice.reducer;

export const selectFormValues = (state) => state.rightPanel.property.form;
export const selectPipelineFormValues = (state) => state.rightPanel.pipeline.form;

export const selectFormBlock = (state) => (tabId) => (blockId) =>
  state.rightPanel.property.form?.[tabId]?.[blockId];
export const selectPipelineForm = (state) => (tabId) => (blockId) =>
  state.rightPanel.pipeline.form?.[tabId]?.[blockId];
export const selectIsPropertiesOpen = (state) =>
  state.rightPanel.property.isOpen;
export const selectIsPipelinePropertiesOpen = (state) =>
  state.rightPanel.pipeline.isOpen;
export const selectActiveBlockId = (state) =>
  state.rightPanel.property.activeBlockId;
export const selectBlockProperties = (state) =>
  state.rightPanel.property.blockProperties;
export const selectPipelineBlockProperties = (state) =>
  state.rightPanel.pipeline.blockProperties;
export const selectParamGrid = (state) => (tabId) => (blockId) =>
  state.rightPanel.property.form?.[tabId]?.[blockId]?.param_grid;
export const selectLayerList = (state) => (tabId) => (blockId) =>
  state.rightPanel.property.form?.[tabId]?.[blockId]?.layer_list;

export const selectIsVisualOpened = (state) => state.rightPanel.visual.isOpen;
export const selectSelectedVisual = (state) => state.rightPanel.visual.selected;
export const openFuncDesc = (state) => state.rightPanel.openfunctDesc;
export const getFunctCode = (state) => state.rightPanel.currFunctCode;
export const getFunctName = (state) => state.rightPanel.func_name;
export const selectIsFetchProjectState = (state) =>
  state.rightPanel.isFetchingProjectState;
